import { useCallback, useState } from 'react';

const SIDEBAR_READ_FEATURES_KEY = 'mizfatools.sidebar.read-features';

export const CRAWL_SETTINGS_FEATURE_KEY = 'crawl-settings-v2';

const getReadSidebarFeatures = (): string[] => {
  try {
    const value = localStorage.getItem(SIDEBAR_READ_FEATURES_KEY);
    const features = value ? JSON.parse(value) : [];
    return Array.isArray(features) ? features : [];
  } catch {
    return [];
  }
};

const useSidebarFeatureIndicator = () => {
  const [readFeatures, setReadFeatures] = useState<string[]>(
    getReadSidebarFeatures
  );

  const markAsRead = useCallback((featureKey: string) => {
    setReadFeatures(currentFeatures => {
      if (currentFeatures.includes(featureKey)) return currentFeatures;

      const nextFeatures = [...currentFeatures, featureKey];
      localStorage.setItem(
        SIDEBAR_READ_FEATURES_KEY,
        JSON.stringify(nextFeatures)
      );
      return nextFeatures;
    });
  }, []);

  const isUnread = useCallback(
    (featureKey: string) => !readFeatures.includes(featureKey),
    [readFeatures]
  );

  return { markAsRead, isUnread };
};

export default useSidebarFeatureIndicator;
